import DOMUtils from "./dom-utils";

export default class MessagePoster {
  static postScrollTo(top, padding = 25) {
    const msg = {
      scrollTo: top - padding,
    };

    MessagePoster.postMessage(msg);
  }

  static postHeight(height) {
    const msg = {
      height,
    };

    MessagePoster.postMessage(msg);
  }

  static postBookingStatusBooked(data) {
    const msg = {
      bookingStatus: "booked",
      data,
    };

    MessagePoster.postMessage(msg);
  }

  static postRedirect(url) {
    const msg = {
      redirect: url,
    };

    MessagePoster.postMessage(msg);
  }

  static postMessage(msg) {
    if (window !== window.parent) {
      window.parent.postMessage(msg, "*");
    }
  }
}
